<template>
  <div :class="['key-val-box',{'show-icon': cfg_show_icon}]">
    <div class="d-flex sp-kv-row w-100">
      <div>
        <span class="sp-icon-box">
          <i class="far fa-circle"></i>
        </span>
        <small class="op4">GEN</small>
        <span>
          Z{{data.genotype}} 
          <span class="op4">{{data.breedtype_str}}</span>
        </span>
      </div>

      <div>
        <span class="sp-icon-box">
          <i class="far fa-circle"></i>
        </span>
        <small class="op4">BLOODLINE</small>
        <span class="val-span">
          {{data.bloodline_str}}
        </span>
      </div>

      <div>
        <span class="sp-icon-box">
          <i class="far fa-circle"></i>
        </span>
        <small class="op4">GENDER</small>
        <span class="val-span">
          {{data.gender_str}}
        </span>
      </div>

      <div>
        <!-- <span class="sp-icon-box">
          <i class="far fa-circle"></i>
        </span>
        <small class="op4">COAT</small>
        <span class="val-span">
          -
        </span> -->
      </div>

      <div>
        <span class="sp-icon-box">
          <i class="far fa-circle"></i>
        </span>
        <small class="op4">RACES</small>
        <span class="val-span">
          {{data.horseRaceInfo.racesNumber}}
        </span>
      </div>

      <div>
        <span class="sp-icon-box">
          <i class="far fa-circle"></i>
        </span>
        <small class="op4">GAREER</small>
        <span class="val-span">
          {{data.horseRaceInfo.firstNumber}}/{{data.horseRaceInfo.secondNumber}}/{{data.horseRaceInfo.thirdNumber}}
        </span>
      </div>

      <div>
        <span class="sp-icon-box">
          <i class="far fa-circle"></i>
        </span>
        <small class="op4">WIN RATE</small>
        <span class="val-span">
          {{data.horse_win_rate}}
        </span>
      </div>

      <div>
        <span class="sp-icon-box">
          <i class="far fa-circle"></i>
        </span>
        <small class="op4">OFFSPRING</small>
        <span class="val-span ml-2">
          {{data.offsprings.length}}
          <span>
            <span class="op4">
              {{data.breedLimitInfo.breedLeft}}
              of
              {{data.breedLimitInfo.breedLimit}}
              left
            </span>

            <div class="ui-hover-show-block d-inline-block">
              <i class="fas fa-info-circle text-small ml-2"></i>
              <div class="hover-show pt-2" style="right: 0;width: 250px;">
                <div class="ui-card border-style px-4 py-3 text-small">
                  <p>
                    {{data.breedLimitInfo.breedLeft}} breed left
                  </p>
                  <p class="mb-0 mt-2">
                    <span class="op4">
                      This
                    </span>
                    {{data.gender_str}}
                    <span class="op4">
                      can breed
                    </span>
                    {{data.breedLimitInfo.breedLeft}} times
                    <span class="op4">
                      during the current breeding cycle. Next breeding cycle will commence in 
                    </span>
                     {{data.breedLimitInfo.left_str}}.
                  </p>
                </div>
                <!-- (Next breeding cycle will commence in 
                {{data.breedLimitInfo.left_str}}) -->
              </div>
            </div>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'horseItemNumBlock',
  components: {},
  props: [
    'data',
    'cfg_show_icon',
  ],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .key-val-box{

    font-size: 14px;
    line-height: 22px;

    &.show-icon{
      .sp-kv-row{

        .sp-icon-box{
          display: block;
        }
      }
    }

    .sp-kv-row{
      flex-wrap: wrap;

      &>div{
        width: 25%;
        margin-bottom: 15px;
      }
      div>span{
        display: block;
      }
      .val-span{
        font-size: 16px;
      }
      .sp-icon-box{
        float: left;
        display: none;
        height: 3em;
        line-height: 3em;
        margin-right: 10px;
        opacity: 0.2;
      }
    }

    @media(max-width: 788px){
      .sp-kv-row{

        &>div{
          width: 50%;
        }
      }
    }
  }
</style>